import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap } from 'lucide-react';
import { CHECKOUT_URL, OFFER } from '../data/checkout';
const includes = ['Los 6 tomos completos de metodología', 'Los 4 bonos estratégicos (valor USD 46)', 'Formato PDF listo para proyectar o entregar', 'Garantía total de 7 días sin preguntas'];
function trackCheckout() {
  if (typeof window !== 'undefined' && (window as any).fbq) {
    ;
    (window as any).fbq('track', 'InitiateCheckout', {
      content_name: OFFER.name,
      value: OFFER.price,
      currency: OFFER.currency
    });
  }
}
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-192" data-mp="227jjeu80os2f">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-193" data-mp="225qg9owm4pz6"></div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-194" data-mp="7ubrpbfc8wl0">
        <div className="text-center mb-10" data-id="element-195" data-mp="1mh6j0uul2u3c">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-196" data-mp="1mi97yx8cimgm">
            Tu acceso al Mega Pack
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-197" data-mp="1ho51sg6wmigl">
            Acceso inmediato · Pagas en tu moneda local
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="bg-dark-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-198" data-mp="17stkpr80wz5o">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs whitespace-nowrap" data-id="element-199" data-mp="1vjftxltrkph9">
            🏆 Oferta principal
          </div>

          <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-200" data-mp="g02wo40hugri">
            <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-201" data-mp="hhrrou6c8rlk">
              Mega Pack Metodología de la Investigación 360
            </h3>
            <p className="text-base text-gray-300 mb-6" data-id="element-202" data-mp="mg3153sq1039">
              Los 6 tomos + 4 bonos estratégicos listos para usar en el aula
              desde hoy.
            </p>

            <ul className="text-left max-w-sm mx-auto space-y-2 mb-8 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-203" data-mp="chdhp6l6f7kw">
              {includes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-204" data-mp="3hqk6vvkilx4">
                  <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-205" data-mp="3l01klii30dy0" />
                  <span data-id="element-206" data-mp="3pwrx5vuogreo">{item}</span>
                </li>)}
            </ul>

            <div className="mb-8" data-id="element-207" data-mp="3bxa9xkx15m7f">
              <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-208" data-mp="3bybtyew0xj1a">
                USD 45,00
              </span>
              <div className="flex items-baseline justify-center gap-2" data-id="element-209" data-mp="3g187hr6pioyd">
                <span className="text-2xl md:text-3xl text-white" data-id="element-210" data-mp="2xbmu2bxv13ud">Hoy:</span>
                <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-211" data-mp="2sd1v0fucgq7i">
                  USD 19,90
                </span>
              </div>
            </div>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackCheckout} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-212" data-mp="31cydfzq54su4">
              🟡 QUIERO EL MEGA PACK AHORA
            </Button>

            <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-5" data-id="element-213" data-mp="3b91ojv2z01t7">
              <span className="flex items-center gap-1.5" data-id="element-214" data-mp="3l0nylo3knuud">
                <Lock size={12} className="text-gold" data-id="element-215" data-mp="3l17i398verai" /> Pago seguro
              </span>
              <span className="flex items-center gap-1.5" data-id="element-216" data-mp="2vuh5kb6hdwh">
                <Zap size={12} className="text-gold" data-id="element-217" data-mp="3u1m3s9pqy8ej" /> Acceso inmediato
              </span>
              <span className="flex items-center gap-1.5" data-id="element-218" data-mp="hy2l0wm6lwz7">
                <Shield size={12} className="text-gold" data-id="element-219" data-mp="hxkr46mzruug" /> Garantía 7 días
              </span>
            </div>

            <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-220" data-mp="lxuvjev4yd77">
              <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-221" data-mp="vp7rahk21nii" />
              <p className="text-[11px] text-gray-400 leading-snug" data-id="element-222" data-mp="vrli2e7pcdk9">
                Pagas en tu moneda local. El importe se adapta automáticamente
                al país desde donde compras.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}